module.exports = __webpack_public_path__ + "img/blog-2.9c6e446e.webp";